// ── Checkout ─────────────────────────────────────────
// "Buy" never jumps straight to Shopify's checkout — it adds the item and
// sends the customer to the themed cart page (/cart) first. The cart
// page's own checkout button goes to /checkout from there.
var _checkoutVariantId = null;

function buyNow(variantId) {
  if (!variantId) return;

  // These are one-of-a-kind pieces — a variant can only ever be in the wagon
  // once (same rule as the "+" quick-add). "BUY" can be reached from three
  // places (grid, quick-view modal, product page), so always re-check the
  // live cart before adding rather than trusting cached state, otherwise
  // clicking BUY for the same item from two of those places doubles it.
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var alreadyInCart = (cart.items || []).some(function(item) {
        return String(item.variant_id) === String(variantId);
      });

      if (alreadyInCart) {
        window.location.href = '/cart';
        return;
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function() {
        if (!_wagonVariants) _wagonVariants = {};
        _wagonVariants[String(variantId)] = true;
        window.location.href = '/cart';
      });
    })
    .catch(function() {
      // Couldn't confirm current cart state — fail safe and just go to the
      // cart without adding again, rather than risk a duplicate line.
      window.location.href = '/cart';
    });
}

function goToCheckout() {
  if (!_checkoutVariantId) return;
  buyNow(_checkoutVariantId);
}

// ── Quick-view overlay ────────────────────────────────
// A module's photos are uploaded as one optional cover/group shot followed
// by front1, back1, front2, back2, ... one pair per shirt (an odd total
// image count means there's a leading cover photo; an even count means
// there isn't). If the merchant fills in the "module_sizes" metafield (a
// comma-separated list of sizes, one per shirt, in that same order), a
// plain number (1, 2, 3...) appears directly under each front-facing
// thumbnail in the photo strip, and a one-line key underneath spells out
// what each number means — "1 = M   2 = L   3 = S...".
var _viewerImages = [];
var _viewerIndex = 0;

// The metafield-built COALMINE_OBJECTS dictionary already runs images through
// Liquid's img_url filter (1200x, CDN-resized). The live "/products/handle.js"
// refetch below does not — Shopify's Ajax API hands back the original,
// full-resolution files, often several MB each, which is what was making
// the detail photos crawl in once that fetch resolved. Appending the CDN's
// own width param resizes them the same way img_url would. 1200 matches the
// featured-image width already used for the card/first popup frame, so this
// refetch can't hand photo 1 a lower-res image than what's already showing.
function shopifyResizedUrl(url, width) {
  if (!url) return url;
  var sep = url.indexOf('?') === -1 ? '?' : '&';
  return url + sep + 'width=' + width;
}

function renderViewerGallery(images, sizesCsv) {
  var mainImg = document.getElementById('viewer-main-img');
  var thumbsEl = document.getElementById('viewer-thumbs');
  var keyEl = document.getElementById('viewer-size-key');

  _viewerImages = images || [];
  _viewerIndex = 0;

  if (mainImg) {
    mainImg.src = _viewerImages[0] || '';
    mainImg.style.cursor = '';
    mainImg.onclick = null;
  }

  var prevBtn = document.getElementById('viewer-nav-prev');
  var nextBtn = document.getElementById('viewer-nav-next');
  var showArrows = _viewerImages.length > 1;
  if (prevBtn) prevBtn.style.display = showArrows ? 'flex' : 'none';
  if (nextBtn) nextBtn.style.display = showArrows ? 'flex' : 'none';

  var sizes = (sizesCsv || '').split(',').map(function(s) { return s.trim(); }).filter(function(s) { return s; });
  var hasCover = images.length % 2 === 1;
  var frontStart = hasCover ? 1 : 0;
  var numByIndex = {};
  if (sizes.length) {
    var shirtNum = 1;
    for (var idx = frontStart; idx < images.length; idx += 2) {
      numByIndex[idx] = shirtNum;
      shirtNum++;
    }
  }

  if (thumbsEl) {
    thumbsEl.innerHTML = images.map(function(img, i) {
      var thumbImg = '<img class="viewer-thumb ' + (i === 0 ? 'active' : '') + '" src="' + img + '" loading="lazy" onclick="setViewerThumb(this, \'' + img + '\', ' + i + ')">';
      if (numByIndex[i]) {
        return '<div class="viewer-thumb-wrap">' + thumbImg + '<div class="viewer-thumb-num">' + numByIndex[i] + '</div></div>';
      }
      return thumbImg;
    }).join('');
  }

  if (keyEl) {
    if (sizes.length) {
      keyEl.textContent = sizes.map(function(size, i) { return (i + 1) + ' = ' + size; }).join('   ');
      keyEl.style.display = 'block';
    } else {
      keyEl.textContent = '';
      keyEl.style.display = 'none';
    }
  }
}

// Tap-through arrows on the main photo — same image set and order as the
// thumbnail strip, so the two always stay in sync (clicking a thumbnail
// moves the arrows' position too, and vice versa). Wraps around at both ends.
function viewerGoTo(index) {
  if (!_viewerImages.length) return;
  var len = _viewerImages.length;
  _viewerIndex = ((index % len) + len) % len;
  var mainImg = document.getElementById('viewer-main-img');
  if (mainImg) mainImg.src = _viewerImages[_viewerIndex];
  document.querySelectorAll('.viewer-thumb').forEach(function(t, i) {
    t.classList.toggle('active', i === _viewerIndex);
  });
}

function viewerNext() { viewerGoTo(_viewerIndex + 1); }
function viewerPrev() { viewerGoTo(_viewerIndex - 1); }

// Previous/next piece, in the order the grid is currently showing — so
// after a Shuffle, price sort, search or filter, "Next" is the card that's
// next to it on screen, and filtered-out cards are skipped. Wraps at both
// ends, same as the photo arrows.
var _viewerHandle = null;

function viewerVisibleCards() {
  if (window.acmVisibleCards) return window.acmVisibleCards();
  var viewer = document.getElementById('object-viewer');
  return Array.prototype.slice.call(document.querySelectorAll('.object[data-handle]')).filter(function(c) {
    return c.style.display !== 'none' && !(viewer && viewer.contains(c));
  });
}

function viewerSiblingCard(dir) {
  var cards = viewerVisibleCards();
  if (cards.length < 2) return null;
  var i = cards.findIndex(function(c) { return c.dataset.handle === _viewerHandle; });
  if (i === -1) return null;
  return cards[(i + dir + cards.length) % cards.length];
}

function updateViewerProductNav() {
  var prev = viewerSiblingCard(-1);
  var next = viewerSiblingCard(1);
  var nav = document.getElementById('viewer-prod-nav');
  if (nav) nav.style.display = (prev && next) ? 'flex' : 'none';
  var pt = document.getElementById('viewer-prod-prev-title');
  var nt = document.getElementById('viewer-prod-next-title');
  if (pt) pt.textContent = prev ? prev.dataset.title : '';
  if (nt) nt.textContent = next ? next.dataset.title : '';
}

function viewerGoProduct(dir) {
  var c = viewerSiblingCard(dir);
  if (!c) return;
  openViewer(c.dataset.handle);
  var viewer = document.getElementById('object-viewer');
  if (viewer) viewer.scrollTop = 0;
}
function viewerNextProduct() { viewerGoProduct(1); }
function viewerPrevProduct() { viewerGoProduct(-1); }

function openViewer(handle) {
  _viewerHandle = handle;
  var p = (window.COALMINE_OBJECTS || {})[handle] || {};
  var card = document.querySelector('[data-handle="' + handle + '"]');

  // The card's own data-* attributes are server-rendered straight from Liquid and are
  // always correct, even if the COALMINE_OBJECTS JS dictionary failed to build for
  // some reason (e.g. a special character in another product's data breaking that
  // script block). Prefer them for the fields we can get from the card itself.
  var title = (card && card.dataset.title) || p.title || handle;
  var domPrice = card ? card.dataset.price : null;
  var images = (card && card.dataset.img) ? [card.dataset.img] : (p.images || []);
  var galleryImages = images.length ? images : (p.images || []);

  // Availability, computed once and reused below for both the price and
  // the acquire button — a sold item shows neither.
  var isAvailable = (card && card.dataset.available !== undefined) ? card.dataset.available === 'true' : (p.available !== false);

  document.getElementById('viewer-title').textContent = title;
  var priceEl = document.getElementById('viewer-price');
  if (priceEl) priceEl.textContent = isAvailable ? (domPrice || p.price || 'Not for sale') : '';
  var buyPriceEl = document.getElementById('viewer-buy-price');
  if (buyPriceEl) buyPriceEl.textContent = isAvailable ? (domPrice || p.price || '') : '';

  var sizeLabelEl = document.getElementById('viewer-size-label');
  if (sizeLabelEl) {
    if (p.sizeLabel) {
      sizeLabelEl.textContent = '[ ' + p.sizeLabel + ' ]';
      sizeLabelEl.style.display = 'block';
    } else {
      sizeLabelEl.textContent = '';
      sizeLabelEl.style.display = 'none';
    }
  }

  renderViewerGallery(galleryImages, p.moduleSizes);

  var attrs = document.getElementById('viewer-attrs');
  var rows = [];
  if (p.measurement) rows.push(['Measurement', p.measurement]);
  if (p.touch) rows.push(['Touch', p.touch]);
  if (p.weight) rows.push(['Weight', p.weight]);
  if (p.look) rows.push(['Look', p.look]);
  if (attrs) {
    attrs.innerHTML = rows.map(function(r) {
      return '<div class="viewer-attr-row"><span class="viewer-attr-label">' + r[0] + '</span><span class="viewer-attr-val">' + r[1] + '</span></div>';
    }).join('');
  }

  var meta = document.getElementById('viewer-meta');
  if (meta) {
    meta.innerHTML = (p.meta || []).filter(function(m) { return m[1]; }).map(function(m) {
      return '<div class="viewer-meta-row"><span>' + m[0] + '</span><span>' + m[1] + '</span></div>';
    }).join('');
  }

  // Product description, straight from Shopify's own product description
  // field in Admin (not a metafield) — rendered as HTML since it can
  // contain the merchant's own paragraphs, bold text, or line breaks.
  var descEl = document.getElementById('viewer-description');
  if (descEl) descEl.innerHTML = p.description || '';
  syncDescriptionFold();

  _checkoutVariantId = (card && card.dataset.variant) ? card.dataset.variant : (p.variantId || null);

  // Reflect availability first — a sold item can't be bought regardless of
  // wagon state.
  var alreadyAdded = !!(_wagonVariants && _checkoutVariantId && _wagonVariants[String(_checkoutVariantId)]);
  var acquireBtn = document.getElementById('viewer-acquire');
  if (acquireBtn) {
    acquireBtn.classList.remove('viewer-acquire-sold');
    acquireBtn.disabled = false;
    var buyBox = document.getElementById('viewer-buy');
    if (!isAvailable) {
      acquireBtn.textContent = 'SOLD';
      acquireBtn.disabled = true;
      acquireBtn.onclick = null;
      acquireBtn.classList.add('viewer-acquire-sold');
    } else if (alreadyAdded) {
      acquireBtn.textContent = 'Go to wagon';
      acquireBtn.onclick = function() { window.location.href = '/cart'; };
    } else {
      acquireBtn.textContent = 'ADD TO WAGON';
      acquireBtn.onclick = function() { viewerAddToWagon(); };
    }
  }

  // Pull the full image set from Shopify directly, in case more were added since page load
  fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      // Skip if the visitor already tapped on to another piece while this
      // was loading — otherwise the old piece's photos land on the new one.
      if (_viewerHandle !== handle) return;
      if (data.title) {
        var titleEl = document.getElementById('viewer-title');
        if (titleEl) titleEl.textContent = data.title;
      }
      if (typeof data.description === 'string') {
        var descEl2 = document.getElementById('viewer-description');
        if (descEl2) descEl2.innerHTML = data.description;
        syncDescriptionFold();
      }
      if (!data.images || data.images.length === 0) return;
      // 1200 matches the featured-image width used for the grid card / first
      // popup frame (see data-img below) so the async refresh doesn't hand
      // photo 1 a lower-res version than what's already on screen — that
      // mismatch was the cause of the first photo looking blurrier than the
      // rest right after the popup opened.
      var resized = data.images.map(function(u) { return shopifyResizedUrl(u, 1200); });
      renderViewerGallery(resized, p.moduleSizes);
    })
    .catch(function() {});

  document.getElementById('object-viewer').classList.add('open');
  document.body.style.overflow = 'hidden';
  updateViewerProductNav();

  // The viewer is an overlay on top of the grid, not a real page — without
  // this, the browser's back button has no "viewer open" state to return
  // from, so it skips straight past the grid to whatever page came before
  // it (e.g. the homepage). Pushing a same-URL history entry here gives
  // back-button/swipe-back something to close first.
  if (!_viewerHistoryPushed) {
    history.pushState({ acmViewer: true }, '', location.href);
    _viewerHistoryPushed = true;
  }
}

// Collapsible Description: open by default everywhere (tap to fold); hidden when a piece has none.
function syncDescriptionFold() {
  var wrap = document.getElementById('viewer-desc-wrap');
  var el = document.getElementById('viewer-description');
  if (!wrap || !el) return;
  var has = !!(el.textContent || '').trim();
  wrap.style.display = has ? '' : 'none';
  if (has && !wrap.getAttribute('data-touched')) {
    wrap.open = true;
  }
}

// ADD TO WAGON in the popup. One-of-a-kind pieces: a variant can only be in
// the wagon once, same rule as the grid's "+".
function viewerAddToWagon() {
  var variantId = _checkoutVariantId;
  var btn = document.getElementById('viewer-acquire');
  if (!variantId || !btn) return;
  if (_wagonVariants && _wagonVariants[String(variantId)]) {
    window.location.href = '/cart';
    return;
  }
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function(r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function() {
      if (!_wagonVariants) _wagonVariants = {};
      _wagonVariants[String(variantId)] = true;
      reflectWagonState();
      btn.disabled = false;
      btn.textContent = 'Go to wagon';
      btn.onclick = function() { window.location.href = '/cart'; };
      showWagonToast('Added to the wagon');
    })
    .catch(function() {
      btn.disabled = false;
      showWagonToast('Could not add. Try again');
    });
}

var _viewerHistoryPushed = false;

function closeViewer(fromPopState) {
  _checkoutVariantId = null;
  var viewer = document.getElementById('object-viewer');
  var wasOpen = !!(viewer && viewer.classList.contains('open'));
  if (viewer) viewer.classList.remove('open');
  document.body.style.overflow = '';

  if (!fromPopState && wasOpen && _viewerHistoryPushed) {
    // Closed via the X/back link/Escape, not the browser's own back button —
    // consume the history entry we pushed so it doesn't sit there as an
    // extra, invisible "back" step later.
    _viewerHistoryPushed = false;
    history.back();
  } else if (fromPopState) {
    _viewerHistoryPushed = false;
  }
}

window.addEventListener('popstate', function() {
  var viewer = document.getElementById('object-viewer');
  if (viewer && viewer.classList.contains('open')) {
    closeViewer(true);
  }
});

function setViewerThumb(el, src, index) {
  document.getElementById('viewer-main-img').src = src;
  document.querySelectorAll('.viewer-thumb').forEach(function(t) { t.classList.remove('active'); });
  el.classList.add('active');
  if (typeof index === 'number') _viewerIndex = index;
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeViewer();
    closeImageZoom();
  }
  var viewer = document.getElementById('object-viewer');
  if (viewer && viewer.classList.contains('open')) {
    if (e.key === 'ArrowRight') viewerNext();
    if (e.key === 'ArrowLeft') viewerPrev();
  }
  var zoom = document.getElementById('image-zoom');
  if (zoom && zoom.classList.contains('open')) {
    if (e.key === 'ArrowRight') zoomNext();
    if (e.key === 'ArrowLeft') zoomPrev();
  }
});

// ── Product page image zoom ────────────────────────────
// Opens to a specific photo by index into window.COALMINE_ZOOM_IMAGES (set
// inline by product.liquid) and can then step through the rest of the
// gallery with arrows/keyboard, instead of only ever showing the one
// photo that was clicked with no way to see the others without closing
// and reopening.
var _zoomIndex = 0;

function updateZoomArrows() {
  var images = window.COALMINE_ZOOM_IMAGES || [];
  var prevBtn = document.getElementById('zoom-nav-prev');
  var nextBtn = document.getElementById('zoom-nav-next');
  var show = images.length > 1;
  if (prevBtn) prevBtn.style.display = show ? 'flex' : 'none';
  if (nextBtn) nextBtn.style.display = show ? 'flex' : 'none';
}

function openImageZoom(index) {
  var images = window.COALMINE_ZOOM_IMAGES || [];
  var zoom = document.getElementById('image-zoom');
  var img = document.getElementById('image-zoom-img');
  if (!zoom || !img || !images.length) return;
  _zoomIndex = typeof index === 'number' ? index : 0;
  img.src = images[_zoomIndex];
  zoom.classList.add('open');
  document.body.style.overflow = 'hidden';
  updateZoomArrows();
}

function zoomGoTo(index) {
  var images = window.COALMINE_ZOOM_IMAGES || [];
  if (!images.length) return;
  var len = images.length;
  _zoomIndex = ((index % len) + len) % len;
  var img = document.getElementById('image-zoom-img');
  if (img) img.src = images[_zoomIndex];
}

function zoomNext() { zoomGoTo(_zoomIndex + 1); }
function zoomPrev() { zoomGoTo(_zoomIndex - 1); }

// The product page's own inline gallery (one photo + arrows, above the
// thumbnail strip) — separate from the full-screen zoom above, though the
// two stay in sync: opening zoom starts from whichever photo is showing
// inline, and closing zoom leaves the inline photo on whatever was last
// zoomed to.
var _pageGalleryIndex = 0;

function pageGalleryRender() {
  var images = window.COALMINE_PAGE_IMAGES || [];
  var img = document.getElementById('object-page-main-img');
  if (img && images.length) img.src = images[_pageGalleryIndex];
  document.querySelectorAll('#object-page-thumbs .viewer-thumb').forEach(function(t, i) {
    t.classList.toggle('active', i === _pageGalleryIndex);
  });
}

function pageGalleryGoTo(index) {
  var images = window.COALMINE_PAGE_IMAGES || [];
  if (!images.length) return;
  var len = images.length;
  _pageGalleryIndex = ((index % len) + len) % len;
  pageGalleryRender();
}

function pageGalleryNext() { pageGalleryGoTo(_pageGalleryIndex + 1); }
function pageGalleryPrev() { pageGalleryGoTo(_pageGalleryIndex - 1); }

function closeImageZoom() {
  var zoom = document.getElementById('image-zoom');
  if (!zoom || !zoom.classList.contains('open')) return;
  if (document.getElementById('object-page-main-img')) {
    pageGalleryGoTo(_zoomIndex);
  }
  zoom.classList.remove('open');
  document.body.style.overflow = '';
}

// ── Mobile nav ────────────────────────────────────────
function toggleNav() {
  var links = document.getElementById('dept-nav');
  if (links) links.classList.toggle('open');
}

// ── Quick add (card "+" → flies to the wagon) ──────────
// These items are one-of-a-kind, so a variant can only ever be in the
// wagon once. We track what's already in the cart so a second click on
// the same product doesn't add a second unit — it just tells you it's
// already there.
var _wagonToastTimeout = null;
var _wagonVariants = null;

function primeWagonState() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      _wagonVariants = {};
      (cart.items || []).forEach(function(item) {
        _wagonVariants[String(item.variant_id)] = true;
      });
      reflectWagonState();
    })
    .catch(function() { _wagonVariants = _wagonVariants || {}; });
}

function reflectWagonState() {
  if (!_wagonVariants) return;
  document.querySelectorAll('.object[data-variant]').forEach(function(card) {
    var btn = card.querySelector('.quick-add-btn');
    if (!btn) return;
    if (_wagonVariants[String(card.dataset.variant)]) {
      btn.classList.add('added');
      btn.textContent = '✓';
    } else {
      btn.classList.remove('added');
      btn.textContent = '+';
    }
  });
}

function quickAdd(evt, btn) {
  evt.stopPropagation();
  evt.preventDefault();

  var card = btn.closest('.object');
  var wagon = document.getElementById('nav-wagon-mark');
  if (!card || !wagon) return;

  if (card.dataset.available === 'false') return;

  var variantId = card.dataset.variant;
  if (!variantId) return;

  if (_wagonVariants && _wagonVariants[String(variantId)]) {
    showWagonToast('Already in the wagon');
    return;
  }

  var startRect = btn.getBoundingClientRect();
  var endRect = wagon.getBoundingClientRect();
  var size = 30;

  var fly = document.createElement('div');
  fly.className = 'quick-add-fly';
  fly.textContent = '+';
  fly.style.top = (startRect.top + startRect.height / 2 - size / 2) + 'px';
  fly.style.left = (startRect.left + startRect.width / 2 - size / 2) + 'px';
  document.body.appendChild(fly);

  // Force a layout pass so the transition below actually animates.
  fly.getBoundingClientRect();

  requestAnimationFrame(function() {
    fly.style.top = (endRect.top + endRect.height / 2 - size / 2) + 'px';
    fly.style.left = (endRect.left + endRect.width / 2 - size / 2) + 'px';
    fly.style.transform = 'scale(0.35)';
    fly.style.opacity = '0.5';
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function() {
      if (!_wagonVariants) _wagonVariants = {};
      _wagonVariants[String(variantId)] = true;
      reflectWagonState();
    })
    .catch(function() {});

  setTimeout(function() {
    fly.remove();
    wagon.classList.add('wagon-hit');
    setTimeout(function() { wagon.classList.remove('wagon-hit'); }, 300);
    showWagonToast('Added to the wagon');
  }, 650);
}

function showWagonToast(message) {
  var toast = document.getElementById('wagon-toast');
  if (!toast) return;
  toast.textContent = message || 'Added to the wagon';
  toast.classList.add('show');
  clearTimeout(_wagonToastTimeout);
  _wagonToastTimeout = setTimeout(function() {
    toast.classList.remove('show');
  }, 2200);
}

document.addEventListener('DOMContentLoaded', primeWagonState);

// (Filters, search and views now live in shop.js.)

// ── Merge all pagination pages into one grid (Shop) ────────────────────
// Shopify hard-caps collection.products at 50 items per Liquid render, so
// a collection past 50 pieces needs real <paginate> pages server-side —
// but that meant Shuffle, and the category/size filters, only ever saw
// whichever ~50 products happened to be on the page you were looking at.
// This walks the pagination links in the background right after load,
// fetching each later page's HTML, and merges its product cards (plus any
// category/size pill options not already present) into this page's grid —
// so by the time anyone actually taps Shuffle or a filter, the whole
// collection is already sitting in the DOM. If a fetch ever fails, it just
// stops there and leaves the visible prev/next page links as a fallback.
// Remembered shuffle order is scoped per collection (see
// ACM_SHOP_COLLECTION_HANDLE, set inline by objects-collection.liquid) so
// shuffling on one collection page doesn't bleed into another, and kept in
// sessionStorage — same lifetime as the splash gate and Source's liked
// items — so it survives navigating away and back within a visit but
// doesn't linger stale forever.
function shuffleStorageKey() {
  return 'acm_shop_shuffle_order_' + (window.ACM_SHOP_COLLECTION_HANDLE || 'default');
}

function saveShuffleOrder(cards) {
  try {
    var handles = cards.map(function(card) { return card.dataset.handle; });
    sessionStorage.setItem(shuffleStorageKey(), JSON.stringify(handles));
  } catch (e) {}
}

// Re-applies a previously-saved shuffle order: cards it already covers get
// moved back into that exact order, so the grid looks unchanged across a
// nav round-trip or the page-2+ merge instead of visibly re-shuffling.
// Anything the saved order doesn't cover yet — new cards that just merged
// in from a later page — gets shuffled among itself and appended after,
// then folded into the saved order for next time. This used to instead
// trigger one full fresh reshuffle of the whole grid whenever the merge
// added cards, which is what caused the visible "shuffles, then shuffles
// again" jump on load: the already-shown 50-card order got thrown away
// and randomized again from scratch the moment the rest of the collection
// finished merging in.
function restoreShuffleOrder() {
  var grid = document.getElementById('objects-grid');
  if (!grid) return;
  var saved;
  try {
    var raw = sessionStorage.getItem(shuffleStorageKey());
    saved = raw ? JSON.parse(raw) : null;
  } catch (e) {
    saved = null;
  }
  if (!saved || !saved.length) return;

  var byHandle = {};
  grid.querySelectorAll('.object').forEach(function(card) {
    byHandle[card.dataset.handle] = card;
  });

  saved.forEach(function(handle) {
    var card = byHandle[handle];
    if (card) grid.appendChild(card);
  });

  var newHandles = Object.keys(byHandle).filter(function(handle) {
    return saved.indexOf(handle) === -1;
  });
  if (newHandles.length) {
    for (var i = newHandles.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = newHandles[i];
      newHandles[i] = newHandles[j];
      newHandles[j] = tmp;
    }
    newHandles.forEach(function(handle) { grid.appendChild(byHandle[handle]); });
    saveShuffleOrder(Array.prototype.slice.call(grid.querySelectorAll('.object')));
  }
}

// Grid starts shuffled by default now, not in the collection's plain
// alphabetical/manual order — feels more like digging through a pile than
// reading a catalog. Shuffled once per session, not once per page view: a
// saved order from earlier this session is always restored rather than
// reshuffled from scratch, so it stays put across navigation and across
// the page-2+ merge. Also flips on .shuffle-ready (see main.css), which is
// what actually reveals the grid — it's hidden until here so the very
// first paint anyone sees is already in its final order, not a flash of
// plain alphabetical order before this runs.
function ensureShuffledOrder() {
  var grid = document.getElementById('objects-grid');
  if (!grid) return;
  var saved;
  try {
    var raw = sessionStorage.getItem(shuffleStorageKey());
    saved = raw ? JSON.parse(raw) : null;
  } catch (e) {
    saved = null;
  }
  if (saved && saved.length) {
    restoreShuffleOrder();
  } else {
    shuffleObjectsGrid();
  }
  grid.classList.add('shuffle-ready');
}

function mergeAllProductPages() {
  var grid = document.getElementById('objects-grid');
  var pagination = document.getElementById('pagination');
  var nextLink = document.getElementById('pagination-next');
  if (!grid) return;
  if (!nextLink) {
    // Nothing to merge (collection fits on one page) — still worth
    // making sure this page's own cards start shuffled.
    ensureShuffledOrder();
    document.dispatchEvent(new Event('acm:merged'));
    return;
  }

  function mergePillOptions(sourceDoc) {
    ['type', 'size'].forEach(function(attr) {
      var rowId = attr + '-pill-row';
      var ourRow = document.getElementById(rowId);
      var theirRow = sourceDoc.getElementById(rowId);
      if (!ourRow || !theirRow) return;
      theirRow.querySelectorAll('.type-pill').forEach(function(theirBtn) {
        var val = theirBtn.getAttribute('data-' + attr);
        if (!val) return;
        var exists = ourRow.querySelector('.type-pill[data-' + attr + '="' + val + '"]');
        if (!exists) {
          var clone = document.importNode(theirBtn, true);
          clone.classList.remove('is-on');
          ourRow.appendChild(clone);
        }
      });
    });
  }

  function fetchNext(url) {
    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('objects-grid');
        if (newGrid) {
          Array.prototype.slice.call(newGrid.querySelectorAll('.object')).forEach(function(card) {
            grid.appendChild(document.importNode(card, true));
          });
        }
        mergePillOptions(doc);
        var nextBtn = doc.getElementById('pagination-next');
        if (nextBtn && nextBtn.getAttribute('href')) {
          fetchNext(nextBtn.getAttribute('href'));
        } else {
          if (pagination) {
            // Everything's merged into this one page now — the prev/next
            // links would just reload a subset of what's already here.
            pagination.style.display = 'none';
          }
          // Whole collection is finally in the DOM — make sure it's
          // shuffled (or the existing shuffle order restored) now that
          // every card that's going to exist actually exists.
          ensureShuffledOrder();
          document.dispatchEvent(new Event('acm:merged'));
        }
      })
      .catch(function() {
        // Network hiccup or similar — leave the visible pagination alone
        // so browsing still works manually even though the merge stalled,
        // but still make sure whatever did make it into the DOM is shuffled.
        ensureShuffledOrder();
        document.dispatchEvent(new Event('acm:merged'));
      });
  }

  fetchNext(nextLink.getAttribute('href'));
}

// Run immediately, synchronously, right here — not inside a
// DOMContentLoaded listener — because waiting was the actual cause of the
// visible "flash" this used to have: mergeAllProductPages only re-applied
// order after its page-2+ fetch finished (a real network round trip, a
// few hundred ms), so the grid would render in default order first and
// only snap to shuffled once that fetch resolved. This script tag loads
// after the grid's own markup (see theme.liquid), so the page's own ~50
// cards already exist in the DOM at this point — safe to shuffle/restore
// them immediately, before any network wait, so there's nothing to see
// change. The grid itself stays invisible (main.css) until this runs, as
// a second line of defence — even if the browser managed to paint a frame
// before this line executed, nothing would be visible yet. mergeAllProductPages
// calls this again later too, once the whole collection has actually
// finished merging in — but per the restoreShuffleOrder rewrite above,
// that call only shuffles in the newly-arrived cards, it no longer
// reshuffles the ones already on screen.
ensureShuffledOrder();

document.addEventListener('DOMContentLoaded', mergeAllProductPages);

// ── Shuffle button (Objects grid) ──────────────────────
// Reorders the actual .object DOM nodes (Fisher-Yates), not just a visual
// trick — appendChild on a node already in the document moves it instead
// of duplicating it. Works whether or not type/size pills are active,
// since filtering only ever toggles display:none/'' and never depends on
// DOM order.
function shuffleObjectsGrid() {
  var grid = document.getElementById('objects-grid');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.object'));
  for (var i = cards.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = cards[i];
    cards[i] = cards[j];
    cards[j] = tmp;
  }
  cards.forEach(function(card) { grid.appendChild(card); });
  // Remembered for this browsing session, so leaving for another page
  // (e.g. Let us hunt for you) and coming back to the shop restores this
  // order instead of resetting to the default one.
  saveShuffleOrder(cards);
}

// ── Sort by price (Objects grid) ───────────────────────
// A plain two-state toggle rather than a saved/persisted order like
// Shuffle — sorting is a one-off "let me see cheapest/priciest first"
// action, not something worth remembering across a nav round-trip.
// Shuffle stays the way back to random order.
var _priceSortDir = null; // null | 'asc' | 'desc'
function sortObjectsGridByPrice() {
  var grid = document.getElementById('objects-grid');
  if (!grid) return;
  _priceSortDir = _priceSortDir === 'asc' ? 'desc' : 'asc';
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.object'));
  cards.sort(function(a, b) {
    var pa = parseFloat(a.dataset.priceNum) || 0;
    var pb = parseFloat(b.dataset.priceNum) || 0;
    return _priceSortDir === 'asc' ? pa - pb : pb - pa;
  });
  cards.forEach(function(card) { grid.appendChild(card); });

  var btn = document.getElementById('sort-price-btn');
  var label = document.getElementById('sort-price-label');
  var arrow = document.getElementById('sort-price-arrow');
  if (label) label.textContent = _priceSortDir === 'asc' ? 'Sort: Price low–high' : 'Sort: Price high–low';
  if (arrow) arrow.textContent = _priceSortDir === 'asc' ? '↑' : '↓';
  if (btn) btn.classList.add('has-active');
}
// ── Floating contact popup (pickaxe button) ────────────
// Tapping the pickaxe opens a small menu of ways to reach us, instead of
// jumping straight to one destination. Closes on a second tap, an outside
// click, or Escape.
function initContactFab() {
  var trigger = document.getElementById('info-fab');
  var popup = document.getElementById('info-fab-popup');
  if (!trigger || !popup) return;

  function closePopup() {
    popup.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }
  function openPopup() {
    popup.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  trigger.addEventListener('click', function(e) {
    e.stopPropagation();
    if (popup.classList.contains('is-open')) closePopup(); else openPopup();
  });

  // Exposed so other on-page buttons (e.g. the Work with ACM / Talk to ACM
  // CTAs) can open this same popup — Instagram/email, whichever's filled
  // in under Theme Settings → Contact — instead of duplicating that UI or
  // linking off to a hardcoded destination. The popup is position:fixed
  // bottom-left, so it opens correctly regardless of scroll position.
  window.openContactPopup = openPopup;

  document.addEventListener('click', function(e) {
    if (!popup.classList.contains('is-open')) return;
    if (popup.contains(e.target) || trigger.contains(e.target)) return;
    closePopup();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closePopup();
  });
}

document.addEventListener('DOMContentLoaded', initContactFab);

// Shared by any "Talk to ACM" / "Work with ACM" button (currently just the
// Work with ACM page). Prefers the floating contact popup opened above,
// but that popup only exists in the DOM if Theme Settings → Contact has
// an Instagram link or email filled in — if both are blank, the button
// falls back to its own data-fallback-href (same settings, read directly
// in Liquid) so a click always does *something* instead of silently
// failing with no feedback at all.
function talkToAcm(btn) {
  if (window.openContactPopup) {
    window.openContactPopup();
    return;
  }
  var href = btn && btn.getAttribute('data-fallback-href');
  if (href) window.open(href, '_blank', 'noopener');
}



